import { render, staticRenderFns } from "./FooterImageSelector.vue?vue&type=template&id=1c9a4325&scoped=true&"
import script from "./FooterImageSelector.vue?vue&type=script&lang=js&"
export * from "./FooterImageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9a4325",
  null
  
)

export default component.exports